import { useSearchParams } from 'react-router-dom';

/**
 * Where Dodo returns a Dunea Desktop plan purchase or card update. The plan itself is applied
 * by Dodo's webhook, not here — this page only sends the buyer back to the
 * app, which re-reads its balance when its window regains focus.
 */
export default function DesktopCheckoutPage() {
  const [params] = useSearchParams();
  const status = params.get('status');
  const cardUpdated = status === 'card-updated';
  const credits = status === 'credits';

  return (
    <div className="ui-root min-h-dvh bg-page flex items-center justify-center p-5 sm:p-8">
      <div className="w-full max-w-[440px] text-center">
        <div className="ui-caption text-accent mb-3">Dunea Desktop</div>
        <h1 className="ui-serif text-[32px] sm:text-[40px] leading-[1.05] text-primary m-0 mb-3">
          {credits ? (
            <>
              Credits <span className="italic text-accent">added</span>
            </>
          ) : cardUpdated ? (
            <>
              Card <span className="italic text-accent">updated</span>
            </>
          ) : (
            <>
              You're all <span className="italic text-accent">set</span>
            </>
          )}
        </h1>
        <p className="text-[13.5px] text-secondary leading-relaxed mb-8">
          {credits
            ? 'Your new credits show up in Dunea Desktop within a minute, and they never expire with your plan.'
            : cardUpdated
              ? 'Your Dunea Desktop plan will renew on the new card.'
              : 'Your plan is active. Your new credits show up in the app within a minute.'}
        </p>
        {/* dunea:// is registered by the desktop app; the OS launches or focuses it */}
        <button
          className="ui-btn-accent w-full !py-3 !text-[14px]"
          onClick={() => {
            window.location.href = 'dunea://focus';
          }}
        >
          Open Dunea Desktop
        </button>
      </div>
    </div>
  );
}
